import gsap from 'gsap';
import Sniffer from 'sniffer';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
import { app } from '@/utils/store';

import nodata from './data';

const data = nodata[app.language];

gsap.registerPlugin(DrawSVGPlugin);

class Carousel {
  constructor() {
    this.carousel = {
      el: document.querySelector('.s-carousel'),
      item: document.querySelectorAll('.carousel-item'),
      block: document.querySelectorAll('.carousel-block'),
    };

    this.indicator = {
      el: document.querySelector('.carousel-indicator svg'),
      outer: document.querySelector('.carousel-indicator .outer'),
    };

    this.state = {
      next: 1,
      step: 1,
      current: 0,
      animate: false,
    };
  }

  init() {
    document.fonts.ready.then(() => {
      this.set();
    });

    if (Sniffer.isPhone) {
      this.carousel.item[1].remove();
    }

    this.events();
  }

  set = () => {
    this.state.animate = false;

    // indicator
    if (Sniffer.isPhone) {
      this.state.indicator = (100 / data.slides.length) * (this.state.current + 1);
    } else {
      this.state.indicator = (100 / Math.round(data.slides.length / 2)) * (this.state.step);
    }

    gsap.set(this.indicator.outer, {
      rotation: 180,
      transformOrigin: 'center center',
      drawSVG: `${this.state.indicator}% 0%`,
    });

    // state
    this.state.step += 1;

    if (Sniffer.isPhone) {
      if (this.state.current === data.slides.length - 1) {
        this.state.current = 0;
      } else {
        this.state.current += 1;
      }
    } else {
      this.state.current += 2;
      this.state.next = this.state.current + 1;
      if (this.state.next > data.slides.length) {
        this.state = {
          next: 1,
          step: 1,
          current: 0,
        };
      }
    }
  }

  events() {
    this.indicator.el.addEventListener('click', this.out);
  }

  out = () => {
    if (this.state.animate === true) return;

    this.state.animate = true;

    [...this.carousel.block].forEach((e) => {
      const h = e.querySelector('h4');
      const l = e.querySelectorAll('li');

      gsap.to(h, {
        opacity: 0,
        duration: 1,
      });

      if (l.length > 0) {
        gsap.to(l, {
          opacity: 0,
          duration: 0.5,
          stagger: 0.05,
          ease: 'expo.in',
          y: -window.innerWidth * 0.01042,
        });
      }
    });

    setTimeout(() => {
      this.create();
    }, 1100);
  }

  create = () => {
    [...this.carousel.block].forEach((e) => {
      e.remove();
    });

    [...this.carousel.item].forEach((e) => {
      const b = document.createElement('div');
      const h = document.createElement('h4');
      const u = document.createElement('ul');

      b.classList.add('carousel-block');

      b.appendChild(h);
      b.appendChild(u);
      e.appendChild(b);
    });

    this.carousel.block = document.querySelectorAll('.carousel-block');

    // 1
    this.carousel.block[0].querySelector('h4').innerHTML = data.slides[this.state.current].h4;
    this.carousel.block[0].querySelector('h4').style.opacity = 0;

    [...data.slides[this.state.current].ul].forEach((e) => {
      const l = document.createElement('li');
      l.innerHTML = e;
      this.carousel.block[0].querySelector('ul').appendChild(l);
      gsap.set(l, {
        opacity: 0,
        y: window.innerWidth * 0.01042,
      });
    });

    // return
    if (this.state.next === data.slides.length) {
      this.in();
      return;
    }

    if (Sniffer.isPhone) {
      this.in();
      return;
    }

    // 2
    this.carousel.block[1].querySelector('h4').innerHTML = data.slides[this.state.next].h4;
    this.carousel.block[1].querySelector('h4').style.opacity = 0;

    [...data.slides[this.state.next].ul].forEach((e) => {
      const l = document.createElement('li');
      l.innerHTML = e;
      this.carousel.block[1].querySelector('ul').appendChild(l);
      gsap.set(l, {
        opacity: 0,
        y: window.innerWidth * 0.01042,
      });
    });

    this.in();
  }

  in = () => {
    [...this.carousel.block].forEach((e) => {
      const h = e.querySelector('h4');
      const l = e.querySelectorAll('li');

      gsap.to(h, {
        opacity: 1,
        duration: 1,
      });

      if (l.length > 0) {
        gsap.to(l, {
          y: 0,
          opacity: 1,
          duration: 2,
          stagger: 0.05,
          ease: 'expo.out',
        });
      }
    });

    if (Sniffer.isPhone) {
      this.state.indicator = (100 / data.slides.length) * (this.state.current + 1);
    } else {
      this.state.indicator = (100 / Math.round(data.slides.length / 2)) * (this.state.step);
    }

    gsap.to(this.indicator.outer, {
      rotation: 180,
      duration: 1.5,
      ease: 'expo.inOut',
      transformOrigin: 'center center',
      drawSVG: `${this.state.indicator}% 0%`,
    });

    setTimeout(() => {
      this.set();
    }, 2000);
  }
}

export default Carousel;
